<template>
  <v-card class="mb-4">
    <v-card-title class="text-h3">
      {{ title }}
    </v-card-title>
    <v-card-text>
      <v-alert
        v-if="warnings.length"
        border="left"
        colored-border
        type="warning"
        icon="mdi-alert"
        elevation="2"
        class="mb-6"
      >
        <div class="font-weight-medium mb-1">
          Перед включением проверьте
        </div>
        <ul class="filial-connection-settings__warnings">
          <li v-for="(item, index) in warnings" :key="index">
            {{ item }}
          </li>
        </ul>
      </v-alert>

      <filial-settings-form
        :value="localSettings"
        :keys="keys"
        :disabled="saving"
        @input="onInput"
      />
      <v-btn
        color="primary"
        :loading="saving"
        @click.prevent="save"
      >
        Сохранить
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
  import FilialSettingsForm from '@/components/ui/crud/fields/filials/FilialSettingsForm.vue'
  import snackbarMessage from '@/mixins/snackbar-message'
  import filialApi from '@/api/filials'

  export default {
    name: 'FilialConnectionSettingsBlock',
    components: { FilialSettingsForm },
    mixins: [snackbarMessage],
    props: {
      title: { type: String, required: true },
      filialId: { type: [Number, String], required: true },
      keys: { type: Array, required: true },
      warnings: { type: Array, default: () => [] },
      settings: { type: Array, default: () => [] },
    },
    data () {
      return {
        localSettings: [],
        saving: false,
        dirty: false,
      }
    },
    watch: {
      settings: {
        immediate: true,
        handler (value) {
          // Не затираем несохранённые правки этого блока перезагрузкой сводки,
          // которую вызвало сохранение соседнего блока
          if (this.dirty) return
          this.localSettings = (value || []).map((item) => ({ ...item }))
        },
      },
    },
    methods: {
      onInput (value) {
        this.localSettings = value
        this.dirty = true
      },
      async save () {
        this.saving = true
        try {
          const items = this.localSettings
            .filter((setting) => this.keys.includes(setting.key))
            .map((setting) => ({
              settingId: setting.settingId,
              value: setting.value,
              isDefaultValue: setting.isDefaultValue,
            }))

          await filialApi.updateSettings(this.filialId, items)
          this.showSuccessMessage('Настройки сохранены')
          this.dirty = false
          this.$emit('updated')
        } catch (e) {
          this.showErrorFromResponse(e)
        }
        this.saving = false
      },
    },
  }
</script>

<style scoped lang="less">
// у .settings-form свои 50px снизу — в карточке подключения кнопка «Сохранить» и так рядом
::v-deep .settings-form {
  margin-bottom: 0;
}

.filial-connection-settings {
  &__warnings {
    padding-left: 18px;

    li + li {
      margin-top: 4px;
    }
  }
}
</style>
